var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!./TrainingNotes.js"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler?id=data-v-49715dd8!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./TrainingNotes.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/TrainingNotes/TrainingNotes.vue
// module id = 639
// module chunks = 0